import { render, staticRenderFns } from "./Authenticator.vue?vue&type=template&id=c14f748c&"
import script from "./Authenticator.vue?vue&type=script&lang=ts&"
export * from "./Authenticator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports